module.exports = __webpack_public_path__ + "img/mode2-2.2df197fb.png";